var map = {
	"./bg_1.jpg": "4832",
	"./bg_10.jpg": "190b",
	"./bg_11.jpg": "7c3a",
	"./bg_12.jpg": "1265",
	"./bg_2.jpg": "475e",
	"./bg_3.jpg": "f43b",
	"./bg_4.jpg": "fb35",
	"./bg_5.jpg": "4cba",
	"./bg_6.jpg": "6701",
	"./bg_7.jpg": "50bb",
	"./bg_8.jpg": "2134",
	"./bg_9.jpg": "57ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b99";